import { ComponentProps } from 'react';
import styled from 'styled-components';

import { Link } from 'components/RouterLink/RouterLink';

import { Button } from './Button';

type Props = ComponentProps<typeof Button> & ComponentProps<typeof Link>;

const StyledLink = styled(Link)`
  text-decoration: none;

  &.full-width {
    width: 100%;
  }
`;

export function RouterButton({
  // common props from Button:
  'aria-label': ariaLabel,
  'data-qa-id': dataQaId,
  'data-qa-submitting': dataQaSubmitting,
  children,
  className,
  disabled,
  fullWidth,
  iconName,
  iconRight,
  id,
  noPadding,
  onBlur,
  onClick,
  onFocus,
  role,
  size,
  tabIndex,
  title,
  type,
  variant,
  // props unique to RouterButton:
  to,
}: Props) {
  return (
    <StyledLink
      to={to}
      className={fullWidth ? 'full-width' : ''}
      // common props:
      aria-label={ariaLabel}
      data-qa-id={dataQaId}
      data-qa-submitting={dataQaSubmitting}
      disabled={disabled}
      id={id}
      onClick={onClick}
    >
      <Button
        className={className}
        disabled={disabled}
        fullWidth={fullWidth}
        iconName={iconName}
        iconRight={iconRight}
        noPadding={noPadding}
        onBlur={onBlur}
        onFocus={onFocus}
        role={role}
        size={size}
        tabIndex={tabIndex}
        title={title}
        type={type}
        variant={variant}
      >
        {children}
      </Button>
    </StyledLink>
  );
}
